// Update the allowed values in the settings heartbeat
export enum ThemeTypes {
    Duotone = 0,
    Carbon = 1,
    Snow = 2,
    Monokai = 3,
    ContrastLight = 4,
    Legacy = 5,
    Classic = 6,
    ContrastDark = 7,
    PassDark = 8,
    Storefront = 9,
    WalletLight = 10,
    StorefrontWallet = 11,
    PassLight = 12,
    WalletDark = 13,
    LumoLight = 14,
    LumoDark = 15,
}

export enum ThemeModeSetting {
    Auto,
    Dark,
    Light,
}

export enum ColorScheme {
    Dark,
    Light,
}

export enum MotionModeSetting {
    No_preference,
    Reduce,
}

export enum ThemeFontSizeSetting {
    DEFAULT = 0,
    X_SMALL,
    SMALL,
    LARGE,
    X_LARGE,
}

export enum ThemeFontFaceSetting {
    DEFAULT,
    SYSTEM,
    ARIAL,
    TIMES,
    DYSLEXIC,
}

export enum ThemeFeatureSetting {
    DEFAULT,
    SCROLLBARS_OFF,
    ANIMATIONS_OFF,
}
